<div>
    <app-simulacion-jardin-administrador [jardin]="jardinSeleccionado" *ngIf="showSimulacion"></app-simulacion-jardin-administrador>
</div>

    <div *ngIf="!showSimulacion" class="projects mb-4">
      <div class="card">
              <div class="card-header header-background">
                    <div class="row">
                        <div class="col-sm-3">
                            <h2>Administración    Usuarios</h2>
                        </div>
                    </div>
              </div>

              <div>
                  <ul class="nav nav-tabs">
                        <li class="nav-item">
                            <a class="nav-link active" data-bs-toggle="tab" href="#adminCuentasJardin">Administrar Cuentas Jardín Infantil</a>
                        </li>
                         <li class="nav-item">
                            <a class="nav-link" data-bs-toggle="tab" (click)="verEncargadosRegionales=true" href="#adminEncargadosRegionales">Administrar Asesores Técnicos</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" data-bs-toggle="tab" (click)="verOtrosPerfiles=true" href="#adminOtrosPerfiles">Administrar Otros Perfiles</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" data-bs-toggle="tab" (click)="verInicioCronograma=true" href="#inicioCronograma"> Cronograma</a>
                        </li>
                  </ul>

                  <div id="myTabContent" class="tab-content">
                      <div class="tab-pane fade show active" id="adminCuentasJardin">
                          <div style="padding: 20px 50px;">
                              <div class="row">
                                <app-cuentas-jardin [infoSelectJardin] = "dataSelects"> </app-cuentas-jardin>
                              </div>
                          </div>
                      </div>

                      <div class="tab-pane fade show" id="adminEncargadosRegionales">
                        <div style="padding: 20px 50px;">
                            <div class="row">
                              <app-cuentas-encargado-regional [infoSelectJardin]="dataSelects" *ngIf="verEncargadosRegionales"></app-cuentas-encargado-regional>
                            </div>
                        </div>
                    </div>

                      <div class="tab-pane fade show" id="adminOtrosPerfiles">
                          <div style="padding: 20px 50px;">
                              <div class="row">
                                <app-cuentas-usuario [infoSelectJardin] = "dataSelects" *ngIf="verOtrosPerfiles"></app-cuentas-usuario>
                              </div>
                          </div>
                      </div>

                      <div class="tab-pane fade show" id="inicioCronograma">
                          <div style="padding: 20px 50px;">
                              <div class="row">
                                <app-inicio-cronograma  [infoSelectJardin] = "dataSelects" *ngIf="verInicioCronograma"></app-inicio-cronograma> 
                              </div>
                          </div>
                      </div>

                  </div>

              </div>
      </div>
    </div>